import type { QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import type { StepTemplatePageQueryParams } from "./StepTemplatePage";
import { StepTemplatePage } from "./StepTemplatePage";
export interface CreateStepTemplatePageProps {
    spaceId: string;
    actionType: string;
    queryParams: StepTemplatePageQueryParams;
    setQueryParams: QueryParamValuesSetter<StepTemplatePageQueryParams>;
}
export function CreateStepTemplatePage({ spaceId, actionType, queryParams, setQueryParams }: CreateStepTemplatePageProps) {
    return <StepTemplatePage spaceId={spaceId} actionType={actionType} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
